import {environment} from "../environments/environment";
import * as Sentry from "@sentry/angular";
import {resolveEnvironmentType} from "./environment.resolver";
import {ErrorHandler, Provider} from "@angular/core";
import {Router} from "@angular/router";


export function initSentry() {
  if (environment.production) {
    Sentry.init({
      dsn: "https://392a882ce96dd2f29a1ffb5e22f87947@sentry.tools.nm-development.de/4",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false
        }),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^\w*\.cheqme\.app/, /^api\.\w*\.cheqme\.app/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      profilesSampleRate: 1.0, // Capture 100% of the profiles
      // Bug #443 — this used to be `environment.production ? Production : Development`, which is
      // unconditionally `"production"`: the ternary only runs inside `if (environment.production)`, and
      // ONE production bundle ships unchanged to int01, prev01 and prod01, so no build-time constant can
      // tell them apart. The deployment is therefore derived at runtime from the hostname — the same
      // signal `endpoint.config.ts` already uses for BASE_URL. See `environment.resolver.ts` for the
      // rule and why its default is `production`.
      environment: resolveEnvironmentType(window.location.hostname)
    });
  }
}

export const SENTRY_ERRORHANDLING_PROVIDER: Provider[] = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false
    })
  },
  {
    provide: Sentry.TraceService,
    deps: [Router]
  }
]
